import ListSubheader from "@mui/material/ListSubheader";
import Typography from "@mui/material/Typography";
import { Box, Button, MultiSelect, Text } from "designSystem/index";
import { ComponentItem } from "designSystem/types/component-item-types";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { slimCardItems } from "designSystemLegacy/data";
import React, { ReactElement } from "react";
import { ListChildComponentProps, VariableSizeList } from "react-window";

export default () => {
	const selectActions = [
		<Button
			design="link"
			onClick={() => console.log("GoToDialog action")}
			res="GoToDialog"
		/>,
	];

	const manyItems: ComponentItem[] = slimCardItems.concat([]);

	for (let i=1; i<=200; i++ ) {
		for (let j=0; j<slimCardItems.length; j++) {
			const newItem: ComponentItem = {
				id: manyItems.length.toString()+1,
				name: slimCardItems[j].name + i,
				name2: slimCardItems[j].name2 + i,
				group: "other",
				value: slimCardItems[j].value + i,
			};
			manyItems.push(newItem);
		}
	}

	manyItems[1].invalid = true;
	manyItems[3].disabled = true;
	
	return (
		<CssColumnGrid columns={2}>
			<Box width={200}>
				<Text semiBold text= {"Grouped: " + manyItems.length + " options"} />
				<MultiSelect
					disableClearable
					grouped
					noChips
					options={manyItems}
					selectActions={selectActions}
					suggestedGroups={["CA"]}
				/>
			</Box>
			<Box width={200}>
				<Text semiBold text= {"Not Grouped: " + manyItems.length + " options"} />
				<MultiSelect
					disableClearable
					noChips
					options={manyItems}
					selectActions={selectActions}
					suggestedGroups={["CA"]}
				/>
			</Box>
			<Box width={200}>
				<Text semiBold text= {"Grouped Slim Card: " + manyItems.length + " options"} />
				<MultiSelect
					disableClearable
					grouped
					noChips
					options={manyItems}
					selectActions={selectActions}
					slimCard
					suggestedGroups={["CA"]}
				/>
			</Box>
			<Box width={200}>
				<Text semiBold text= {"Not Grouped Slim Card: " + manyItems.length + " options"} />
				<MultiSelect
					ImageProps={{
						noImageComponent: <Typography>📷</Typography>,
					
					}}
					disableClearable
					noChips
					options={manyItems}
					selectActions={selectActions}
					slimCard
					suggestedGroups={["CA"]}
				/>
			</Box>
		</CssColumnGrid>
	);
};